/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./category-input.vue?vue&type=template&id=1dd74812&scoped=true&"
import script from "./category-input.vue?vue&type=script&lang=js&"
export * from "./category-input.vue?vue&type=script&lang=js&"
import style0 from "./category-input.vue?vue&type=style&index=0&id=1dd74812&prod&lang=scss&scoped=true&"
import style1 from "./category-input.vue?vue&type=style&index=1&id=1dd74812&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd74812",
  null
  
)

export default component.exports